<template>
  <div>
    <div class="col-xs-6 col-sm-6 col-md-6 col-xl-6 contactleft">
      <div class="col-md-12 contactleftpadding">
        <h2 class="contacttitle">We would love to hear from you.</h2>
        If you would like to get more information about what we can do to help you. Please contact us using one of the
        following methods.
        <br/>
      </div>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-6 col-xl-6 contactright">
      <div class="card9">
        <div class="crop-height flip" style="height: 350px;">
          <img alt="" class="scale flip" src="aiImg/contact/typing.jpg"/>
        </div>
      </div>
    </div>
    <div class="col-xs-7 col-sm-8 col-md-8 col-xl-8 contactleft2">
      <div class="col-md-12 contactHeader">
        <h2 class="title2">Want to work with us?</h2>
        <p class="description2" style="color: #ffffff; padding-left:20px; padding-right: 20px;">Join the team.</p><br>

        <div class="col-sm-10 col-xs-9 col-lg-8 col-md-8">
          <fg-input
              v-model="form.name"
              addon-left-icon="now-ui-icons users_circle-08"
              class="input-lg"
              placeholder="First Name..."
          ></fg-input>
          <fg-input
              v-model="form.email"
              addon-left-icon="now-ui-icons ui-1_email-85"
              class="input-lg"
              placeholder="Email Here..."
          ></fg-input>
          <div class="textarea-container">
                        <textarea
                            v-model="form.desc"
                            class="form-control"
                            cols="80"
                            name="name"
                            placeholder="Type a message..."
                            rows="4"
                        ></textarea>
            <div class="send-button">
              <n-button block round size="lg" type="primary" @click="sendMessage">Send Message</n-button>
            </div>
            <br>
          </div>
          <br>
        </div>
      </div>
    </div>

    <div class="col-xs-7 col-sm-7 col-md-7 col-xl-7 contactright2">
      <div class="col-md-12 ">
        <div class="col-md-9 ">
          <div class="card10" style="padding:4%;  ">
            <h5 class="description2" style="margin-bottom: 0; font-weight: 500;  ">
              <h3>Contact Us.</h3>
              Email: info@ai-integration.com
              <br/>
              <br/>
              Phone: 443-832-3719
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="section careersClear"></div>
  </div>

</template>
<script>
const axios = require('axios');

import {Button, FormGroupInput} from '@/components';

export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        desc: ''
      },
      contactURL: "https://rb1h0y448c.execute-api.us-east-1.amazonaws.com/prod/contact-us"
    };
  },
  methods: {
    validateForm(showAlert) {
      var Namere = /[A-Za-z]{1}[A-Za-z]/;
      if (!Namere.test(this.form.name)) {
        showAlert ? alert ("Name can not less than 2 char") : null;
        return false;
      }
      if (!this.form.desc) {
        showAlert ? alert ("Please enter a message!") : null;
        return false;
      }

      var reeamil = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/;
      if (!reeamil.test(this.form.email)) {
        showAlert ? alert ("Please enter valid email address") : null;
        return false;
      }

      return true;
    },
    sendMessage() {
      if (!this.validateForm(true)) {
        return;
      }
      axios.post(this.contactURL, this.form, {
        crossDomain: true
      })
        .then(() => {
          this.form = {
            name: '',
            email: '',
            desc: ''
          }
          console.log("Email: success!");
          alert("Thank you for contacting us! We will be in touch with you shortly.");
        })
        .catch((error) => {
          console.error(error);
          alert("There has been an error contacting the e-mail server. Please try again later.");
        });
    },
  }
};

</script>
<style>
.careersClear {
  clear: both;
}

.contactleft {
  padding: 20px 20px 20px 20px;
}

.contactleft2 {
  margin-top: 50px;
  padding-right: 0;
  padding-left: 0 !important;
}

.contactright {
  float: right;
  margin-top: -180px;
  max-height: 350px;
  padding-right: 0 !important;
  padding-left: 0;
  z-index: 1;
}

.contactright2 {
  float: right;
  margin-top: -80px;
  padding-right: 50px;
  margin-left: 20px;
  z-index: 1;

}

.contactHeader {
  background-color: RGB(3, 113, 113);
  color: #ffffff;
  height: 100%;
  width: 100%;
}

.contactSubHeader {
  background-color: #dddddd;
  float: center;
  color: #222222;
  height: 200px;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 10px;
}

.contacttitle {
  text-align: left;
  font-weight: 500;
  font-size: 2.5em;
  padding-top: 70px;
}

.title2 {
  font-size: 2.5em;
  padding-left: 20px;
  padding-right: 20px;
}

.inputSize {
  width: 100%;
}

.card10 {
  float: right;
}


@media (max-width: 575px) {
  .card9 {
    float: right;
    width: 50%;
    min-width: 0;
    display: block;
    margin: 0;
    height: 300px;
    margin-top: 40px;
  }

  .card10 {
    float: right;
    width: 80%;
    min-width: 250px;
    display: block;
    margin: 0;
    height: 100%;
    margin-top: 60px;
    margin-right: -30px;
  }

  .contactHeader {
    max-width: 70%;
    margin-top: 0;
  }

  .contactleft {
    max-width: 57%;
  }

  .contacttitle {
    font-size: 1.5em;
    font-weight: 490;
  }

  .title2 {
    font-size: 1.5em;
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 767px) {
  .contactHeader {
    max-width: 90%;
    margin-top: 0;
  }
}

@media (max-width: 902px) {
  .contactright2 {
    display: block;
  }

  .body {
    padding-bottom: 30px;
  }
}

@media (max-width: 499px) {
  .contactleftpadding {
    padding-left: 0 !important;
  }

  .card9 {
    height: 200px !important;
  }

  .contactleft2 {
    margin-top: 30px;
  }
}

</style>